<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          申请单号：<span v-if="formData.applyNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
            formData.applyNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 状态 -->
          <span v-if="!dataId" class="information"> 新增</span>
          <span v-else class="information">
            {{
              formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
              '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '9' ? '已结算' : formData.stat == '99' ? '取消' : ''
            }}</span>
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButton && (formData.stat == 1 || formData.stat == 6 || !formData.id)" @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) &&  submitButton"
                     @click="showDealSaleRewardDialog = true; type = '提交'">提交
          </el-button>
<!--          <el-button type="primary" command="e" class="button-sty" icon="el-icon-check"-->
<!--                     v-if="(formData.stat == 1 || formData.stat == 6) && formData.id && !formData.processId && flowSubmitButton"-->
<!--                     @click="startFlow">启动流程-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id != null && formData.stat == 2  && checkButton"
                     @click="showDealSaleRewardDialog = true; type = '审核'">审核
          </el-button>
<!--          <el-button type="primary" class="button-sty" icon="el-icon-close"-->
<!--                     v-if="formData.id != null && (formData.stat == 1 || formData.stat == 6) && !formData.processId && cancelButton"-->
<!--                     @click="showCloseDialog = true; type = '取消'">取消-->
<!--          </el-button>-->
        </div>
      </div>
      <div>
        <div>
          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box" style="height: 100%;margin:0 !important;padding:0 !important;">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    申请类型
                  </th>
                  <td>
                    <el-select v-model="formData.billType" style="width:10vw!important;" @change="changeBillType"
                               clearable >
                      <el-option :value="1" label="激励"></el-option>
                      <el-option :value="2" label="调整"></el-option>
                    </el-select>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    机构名称
                  </th>
                  <td>
                    <el-cascader v-model="orgValue" :options="orgOptions"
                                 :props="{ label: 'name', value: 'id', checkStrictly: true }"
                                 @change="orgHandleChange"></el-cascader>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    网点名称
                  </th>
                  <td v-if="this.currentSiteData !== null">
                    <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="true">
                      <i slot="suffix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </td>
                  <td v-else>
                    <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                    </el-input>
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    金额
                  </th>
                  <td >
                    <el-input type="text" autocomplete="off" v-model="formData.applyAmount" clearable >
                    </el-input>
                  </td>
                </tr>
                <tr >
                  <th>
                    <em class="f-red">*</em>
                    设计工单号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.designOrderNo" clearable
                              readonly>
                      <i slot="suffix" class="el-input__icon el-icon-search" @click="searchOrder"></i>
                    </el-input>
                  </td>
                  <th>
                    安装工单号
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.installOrderNo" disabled/>
                  </td>
                </tr>
                <tr>
                  <th>
                    <em class="f-red">*</em>
                    申请内容
                  </th>
                  <td colspan="7">
                    <el-input type="textarea" autocomplete="off" v-model="formData.applyContent" clearable/>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                <div class="title first"><b>附件列表</b></div>
                <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                           :action="api.uploadFileUrl"
                           accept=".docx,.doc,.txt,.pdf,.xlsx" :limit="3" :show-file-list="false"
                           :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }"
                           :headers="headers"
                           :on-progress="upVideo"

                           :auto-upload="true">
                  <el-button type="primary" class="button-sty btn_zdy">
                    <i class="el-icon-plus"></i>
                    附件
                  </el-button>
                </el-upload>
              </div>
              <div>
                <vxe-table style="margin-top: 0px;" :stripe="true"
                           :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 36, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="210" :column-config="{ resizable: true }"
                           @checkbox-change="selectChangeEvent"
                           @checkbox-all="selectChangeEvent" :data="formData.saleRewardApplyFileDTOList">
                  <vxe-column type="checkbox" width="40"/>
                  <vxe-column field="fileName" title="附件名称" width="400">
                    <template #default="{ row }">
                      <!-- <a :href="row.fileUrl" :download="row.fileName">{{ row.fileName }}</a> -->
                      <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                    </template>
                  </vxe-column>
                  <vxe-column title="操作" width="90">
                    <template #default="{ row }">
                      <div>
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="deleteFile(row)" class="el-icon-delete"
                             style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                                    popper-class="tooltip-skin">
                          <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                             style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
            </div>
            <div class="d-item">
              <div class="title first">
                <b>审核信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                <tr>
                  <th>
                    审核人
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.checkBy" clearable :disabled="able"/>
                  </td>
                  <th>
                    审核时间
                  </th>
                  <td>
                    <el-date-picker v-model="formData.checkDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                    :disabled="able" type="date" placeholder="选择日期">
                    </el-date-picker>
                  </td>
                  <th>
                    审核金额
                  </th>
                  <td>
                    <el-input type="text" autocomplete="off" v-model="formData.checkAmount" clearable
                              :disabled="able"/>
                  </td>
                </tr>
                <tr>
                  <th>
                    审核说明
                  </th>
                  <td colspan="3">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" autocomplete="off"
                              v-model="formData.checkNote" clearable :disabled="able"/>
                  </td>
                  <th>审核附件</th>
                  <td colspan="5">
                    <div class="form_picture">
                      <!-- <photo-upload :photo-url.sync="company.electronicInstructionManual"/> -->
<!--                      <text-upload :photo-url.sync="formData.checkFile" :disabled="able"/>-->
                      <span class="yuLan" v-if="formData.checkFile"  @click.stop="openVideo(formData.checkFile)" >附件1-预览<i class="el-icon-view"  ></i></span>
                      <span class="yuLan" v-if="formData.checkFile2"  @click.stop="openVideo(formData.checkFile2)" style="margin-left: 10px;">附件2-预览<i class="el-icon-view"  ></i></span>
                      <span class="yuLan" v-if="formData.checkFile3"  @click.stop="openVideo(formData.checkFile3)" style="margin-left: 10px;">附件3-预览<i class="el-icon-view"  ></i></span>
                      <span class="yuLan" v-if="formData.checkFile4"  @click.stop="openVideo(formData.checkFile4)" style="margin-left: 10px;">附件4-预览<i class="el-icon-view"  ></i></span>
                      <span class="yuLan" v-if="formData.checkFile5"  @click.stop="openVideo(formData.checkFile5)" style="margin-left: 10px;">附件5-预览<i class="el-icon-view"  ></i></span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="height:250px"></div>
          </div>
        </div>
      </div>
    </el-form>

    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"/>

    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" @commit="siteCommit" :orgId="formData.orgId" :siteFloorLevel="1"
             multi="true"/>
    <dealSaleRewardDialog v-if="showDealSaleRewardDialog" :dataId="formData.id" :confirmNo="formData.applyNo" :type="type"
                 @closeD="closeD"
                 :visiable.sync="showDealSaleRewardDialog" multi="true" @goBackIndex="goBackIndex"/>
    <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL"/>

    <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :showBigSiteName="true"
              :siteId="formData.siteId" :isSelectDesignOrder="formData.billType"
              multi="true"/>
  </div>
</template>
<script>
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import {uploadFileFormat, echoFileFormat} from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import DictSelect from "@/components/formItem/dictSelect.vue";
import request from "@/router/axios";
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import {mapGetters} from "vuex";
import {siteMixins} from "@/mixins/tabChang";
import {dictType, loadDictData} from "@/config/dictType";
// 文件上传
import textUpload from "@/components/formItem/textUpload.vue"
// 流程
import {delObj, fetchTree, syncCpDept, syncCpUser, syncDept, syncUser} from '@/api/admin/dept'
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import dealSaleRewardDialog from "@/views/expense/wkSaleRewardApply/dealSaleRewardDialog.vue";

export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    type: String,

    applyTypeName: [String, Number],
  },
  components: {
    dealSaleRewardDialog,
    Preview,
    textUpload,
    DictSelect,
    checkSubjectSearch,
    orderPop,
    sitePop,
    Tinymce,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      checkFile: [],
      applyTypeName: null,

      fixData: null,

      imgVisbleURL: '',

      showPreview: false,
      processDefinitions: [],

      // 号码验证
      callMobile1: '',

      applyTypeList: [],
      feeTypeValueList: [],

      able: true,

      submitButton: false,
      flowSubmitButton: false,
      checkButton: false,
      rejectButton: false,
      cancelButton: false,

      recallButton: false,
      editButton: true,
      selectedData: [],
      orgOptions: {},
      queryParams: {
        deptName: ""
      },
      orgValue: '',
      showOrderRemaekDialog: false,
      orderRemarkParam: {},

      loading: false,
      // 流程
      processId: '',
      showOrderPop: false,

      wfData: {
        wfEntityId: ''
      },
      initiateAppeal: false,
      formLabelWidth: '80px',
      justShow: false,
      showDealSaleRewardDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,
      isSite: false,
      notFeeTypeFlag: false,
      needFee: true,
      needOrderNoAndBarCodeFlag: false,
      selectSettleFeeType:null,
      isSetSettleFeeType:false,
      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,

      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      formData: {
        designOrderNo:null,
        installOrderNo:null,
        saleRewardApplyFileDTOList:[],
      },
      dataRule: {
        orgId: [
          {
            required: true,
            prop: '部门ID，关联脚手架机构表sys_dept.dept_id',
            message: '部门ID，关联脚手架机构表sys_dept.dept_id不能为空',
            trigger: 'blur'
          }
        ],
        orgName: [
          {required: true, prop: '部门名称,冗余字段', message: '部门名称,冗余字段不能为空', trigger: 'blur'}
        ],
        orgIdPath: [
          {
            required: true,
            prop: '部门ID路径,冗余字段.重要',
            message: '部门ID路径,冗余字段.重要不能为空',
            trigger: 'blur'
          }
        ],
        siteId: [
          {required: true, prop: '网点ID,关联sn_user.id;', message: '网点ID,关联sn_user.id;不能为空', trigger: 'blur'}
        ],
        siteName: [
          {required: true, prop: '网点名称, 冗余字段', message: '网点名称, 冗余字段不能为空', trigger: 'blur'}
        ],
        applyContent: [
          {required: true, prop: '申请内容', message: '申请内容不能为空', trigger: 'blur'}
        ],
      },
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,

      showProductCategoryDialog: false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      dataId: '',
    };
  },
  watch: {
  },

  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    this.editButton = this.permissions["wkSaleRewardApplyEdit"];
    this.submitButton = this.permissions["wkSaleRewardApplySubmit"]; //提交
    this.checkButton = this.permissions["wkSaleRewardApplyCheck"]; //审核

    if (this.currentSiteData) {
      this.isSite = true;
      console.log("this.isSite = true;")
    }
  },

  mounted() {
    this.loadLoginIsSite()
    this.loadOrgData()
    this.getData()
    // this.loadDictData()
  },

  methods: {
    closeD2() {
      this.showPreview = false

    },

    searchOrder() {
      let errorMsg = '';
      if (!this.formData.siteId) {
        errorMsg += '网点 '
      }
      if (!this.formData.billType){
        errorMsg +='申请类型 '
      }
      console.log("searchOrder")
      if (errorMsg) {
        this.$message.error("请选择" + errorMsg);
        return false;
      }

      this.showOrderPop = true;
    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    reloadWf() {
      console.log('保存前的刷新');
      this.$emit('editViewDataUpdate')
    },

    showOrderRemaek() {
      console.log("submitButton", this.submitButton)
      console.log("recallButton", this.recallButton)
      if (!this.recallButton) {
        this.$message.warning('没有回访权限')
      } else {
        this.showOrderRemaekDialog = true;
      }
    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    changeBillType(){
      this.formData.designOrderId = null
      this.formData.designOrderNo = null
      this.formData.installOrderId = null
      this.formData.installOrderNo = null
    },
    getData() {
      // console.log('getData',this.dataId)
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkSaleRewardApply.getDataUrl,
          method: 'post',
          isLoading: true,
          modalStrictly: true,
          data: {
            id: this.dataId,
          }
        }).then(response => {
          let data = response.data.data
          this.formData = data
          this.orgValue = data.orgId
        })
      }
    },

    // 加载产品小类
    loadProductOption1() {
      this.formData.categoryName = this.formData.bigCategoryName + "/" + this.formData.smallCategoryName
    },
    upVideo() {
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      if (this.formData.saleRewardApplyFileDTOList==null){
        this.formData.saleRewardApplyFileDTOList = []
      }
      this.formData.saleRewardApplyFileDTOList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
        message: '附件上传成功',
        type: 'success'
      });
      this.$mask.close()
    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.formData.saleRewardApplyFileDTOList = this.formData.saleRewardApplyFileDTOList.filter(item => item.fileUrl !== row.fileUrl)
      })
    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    followUpOrderRemark(data) {
      this.showOrderRemaekDialog = false;
      console.log("回访数据", data)
      if (!this.formData.virtualBarcodeBillRecalls) {
        this.formData.virtualBarcodeBillRecalls = []
      }
      console.log("回访数据", data)
      let filter = this.formData.virtualBarcodeBillRecalls.filter(item => item.huiFangQingKuang !== data.huiFangQingKuang)
      filter.push(data)
      this.formData.virtualBarcodeBillRecalls = filter
      console.log("this.formData.virtualBarcodeBillRecalls", this.formData.virtualBarcodeBillRecalls)
    },

    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },

    handlePreview(file) {
      console.log(file);
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showDealSaleRewardDialog = false
      // this.flushed()
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },


    //加载判断当前登录是否网点
    loadLoginIsSite() {
      this.$http({
        url: api.snUser.getLoginIsSite,
        method: 'post',
        data: {}
      }).then(res => {
        console.log("this.currentSiteData", this.currentSiteData)
        console.log("当前登录信息", res.data)
        if (res.data.data.userType != null) {
          this.formData.siteMan = this.currentSiteData.snSiteInfoDTO.siteMan
          this.formData.siteMobile = this.currentSiteData.snSiteInfoDTO.siteManMobile
          this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id

        }
      })
    },

    // 加载机构数据
    loadOrgData() {
      fetchTree(this.queryParams).then(response => {
        this.orgOptions = response.data.data
        // this.orgOptions =res.data.data
        console.log(this.orgOptions, "this.orgOptions的值");

      });

    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    saveData() {
      if ( !this.formData.billType) {
        this.$message.error("费用类型必填");
        return false;
      }
      if (!this.formData.designOrderNo) {
        this.$message.error("设计工单号必填");
        return false;
      }
      if (!this.formData.applyAmount) {
        this.$message.error("金额必填");
        return false;
      }
      this.$validate(this.formData, this.dataRule).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()
          var url = (this.isEdit ? api.wkSaleRewardApply.updateDataUrl : api.wkSaleRewardApply.addDataUrl);
          var method = 'post';
          this.$http({
            url: url,
            method: method,
            data: this.formData,
            isLoading: true,
          }).then(response => {
            this.$message.success("保存成功！");
            this.reload()
            this.$mask.close()

          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })
      })



    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },

    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据1111111111')
      this.formData.designOrderId = row.orderId
      this.formData.designOrderNo = row.orderNo
      this.formData.installOrderId = row.installOrderId
      this.formData.installOrderNo = row.installOrderNo
    },

    // 网点弹窗选中
    siteCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.siteId = row.id
      this.formData.siteName = row.name
      this.orgValue = row.orgId
      this.formData.orgId = row.orgId
      this.formData.orgName = row.orgName
      this.formData.orgIdPath = row.orgIdPath
      this.formData.siteMan = row.siteMan
      this.formData.siteMobile = row.siteManMobile
    },
    getProcessDefinitions() {
      request({
        url: api.act.getProcessDefinitionsUrl,
        method: 'post',
        // data:this.formData,
        data: {tableKey: "WkFeeApply",},
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.processDefinitions = response.data.data
      })
    },
    startFlow() {

      console.log("startFlow!!")
      let applyType = this.formData.applyType;
      if (applyType) {
        this.applyTypeList.forEach(item => {
          if (applyType === item.id) {
            this.formData.applyTypeName = item.label
          }
        })
      }
      if (!applyType || !this.formData.applyTypeName) {
        this.$message.error('请选择申请类型');
        return;
      }


      if (!this.processDefinitions || this.processDefinitions.length < 1) {
        this.$message.error('未获取到费用申请单流程');
        return;
      }
      let processDefinitionId = null
      console.log("processDefinitionId")
      this.processDefinitions.forEach(element => {
        if (element.wfName == ("费用申请单-" + this.formData.applyTypeName)) {
          processDefinitionId = element.id
        }
      });
      console.log("processDefinitionId", processDefinitionId)
      if (!processDefinitionId) {
        this.$message.error('未找到对应流程');
        return;
      }
      this.$baseConfirm('您确定要启动流程吗？').then(() => {
        this.$mask.open()
        console.log("this.$mask.open()")
        this.$http({
          url: api.act.startWfUrl,
          method: 'post',
          data: {
            id: this.formData.id,
            tableKey: "WkFeeApply",
            orgId: this.formData.orgId,
            orderNo: this.formData.applyNo,
            processDefinitionId: processDefinitionId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          if (response.data.type == "success") {
            this.$message({message: response.data.content, type: 'success'});
            this.reload();
          } else {
            this.$message({message: response.data.content, type: 'warning'});
          }
          this.$mask.close()
        })
      })
    },
  },
};

</script>
<style lang="scss" scoped>
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 165px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 656px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  // background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}


#containt .detail-wrap .d-cont {
  overflow: unset !important;
  margin: 0 !important;
  padding: 0 !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

::v-deep .el-image {
  width: 60px;
}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
</style>
